import React, { useEffect, useState } from "react";
import { api, fmtMoney } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import DealCard from "@/components/DealCard";
import { Input } from "@/components/ui/input";
import { Search as SearchIcon } from "lucide-react";
import { toast } from "sonner";

export default function Search() {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);

  const run = async (query) => {
    if (!query) {
      const { data } = await api.get("/catalog/offers?limit=24");
      setResults(data);
      return;
    }
    const { data } = await api.get(`/catalog/offers?q=${encodeURIComponent(query)}&limit=30`);
    setResults(data);
  };

  useEffect(() => {
    run("");
  }, []);

  const handleShop = async (offer) => {
    try {
      await api.post("/wallet/click", { offer_id: offer.id });
      await api.post("/wallet/simulate-purchase", { offer_id: offer.id, order_amount: 100 });
      toast.success(`Cashback approved: ${fmtMoney((100 * (offer.cashback_rate || 5)) / 200)}`);
    } catch (e) {
      toast.error("Couldn't track click");
    }
  };

  return (
    <div data-testid="page-search">
      <PageHeader eyebrow="Universal Search" title="Search every category" subtitle="Groceries, travel, credit cards, subscriptions, and more." />
      <form
        onSubmit={(e) => { e.preventDefault(); run(q); }}
        className="relative mb-8"
      >
        <SearchIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
        <Input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Try 'flights to Hawaii', 'baby formula', 'Chase credit card'…"
          className="pl-11 h-12 text-base rounded-2xl"
          data-testid="search-input"
        />
      </form>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {results.map((o) => (
          <DealCard key={o.id} offer={o} onShop={handleShop} />
        ))}
        {results.length === 0 && <div className="text-gray-500">No results. Try a broader query.</div>}
      </div>
    </div>
  );
}
